module.exports = (formValues, requiredFields) => {
  let errors = {}; // Store errors by key: { "phone-number-0": "duplicate" }
  let phoneNumbers = {}; // Track value -> first key found

  for (let key in formValues) {
    // 1. Check Required Fields
    requiredFields.forEach((field) => {
      if (key.includes(field) && !key.includes("participant-category-other")) {
        if (!formValues[key] || formValues[key] === "") {
          errors[key] = "incomplete";
        }
      }
    });

    // 2. Check Duplicates for Phone Numbers
    if (key.includes("phone-number")) {
      const val = formValues[key]?.toString().trim();
      if (val && val !== "") {
        if (phoneNumbers[val]) {
          // Mark both the current key AND the original key as duplicates
          errors[key] = "duplicate";
          errors[phoneNumbers[val]] = "duplicate";
        } else {
          phoneNumbers[val] = key;
        }
      }
    }

    // 3. Check Participant Category "Other"
    if (
      key.includes("participant-category") &&
      !key.includes("participant-category-other")
    ) {
      const val = formValues[key];
      if (val !== "Mandiri" && val !== "Topgolf") {
        const otherKey = key.replace(
          "participant-category",
          "participant-category-other",
        );
        const otherVal = formValues[otherKey];
        if (!otherVal) {
          errors[otherKey] = "incomplete";
        }
      }
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors: errors,
  };
};
